<template>
  <svg viewBox="0 0 59 64" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1)" fill="none"fill-rule="evenodd">
      <g stroke="#A19A98">
        <path d="M30.3 5.14v.88c-.5-.03-1-.04-1.5-.04s-1 .01-1.5.04v-.88c0-.6.4-1 1-1h1c.6 0 1 .4 1 1z" />
        <path d="M27.41 4.71c-1.2-.3-2.1-1-2.1-1.9 0-1.2 1.6-2.1 3.5-2.1s3.5.9 3.5 2.1c0 .9-.9 1.6-2.1 1.9" />
      </g>

      <circle stroke="#A19A98" cx="28.81" cy="34.35" r="23.38" />
      <g transform="translate(0 5)">
        <path d="M57.19 29.36c0 15.67-12.71 28.37-28.38 28.37C13.14 57.73.43 45.03.43 29.36.43 14.18 12.34 1.8 27.31 1.02c.5-.03 1-.04 1.5-.04s1 .01 1.5.04c14.97.78 26.88 13.16 26.88 28.34z" stroke="#A19A98" stroke-width="1.5" />
        <g class="spinner" :class="{ 'spinner-pointer': animated }">
          <path d="M28.56 38.58l-2.44-9.17h5.37l-2.44 9.17c-.07.25-.42.25-.49 0z" fill="#A19A98" fill-rule="nonzero" />
          <path d="M29.05 20.23l2.44 9.18h-5.37l2.44-9.18c.07-.25.42-.25.49 0z" fill="#E22321" fill-rule="nonzero" />
          <circle fill="#FFF" fill-rule="nonzero" cx="28.81" cy="29.4" r="1.12" />
        </g>
      </g>
      <g class="spinner" :class="{ 'spinner-frame': animated }">
        <path fill="#A19A98" fill-rule="nonzero" d="M27.53 17.87h.57l1.43 1.86v-1.86h.56v2.88h-.53l-1.47-1.92v1.92h-.56zM42.99 35.84v-2.96h2.28v.53H43.6v.68h1.1v.52h-1.1v.7h1.68v.53h-2.29zM27.6 50.43l.35-.43c.17.15.33.25.48.32.16.07.32.1.49.1.18 0 .32-.03.43-.1.11-.07.16-.15.16-.26 0-.1-.04-.18-.11-.23a.793.793 0 00-.37-.12l-.57-.1c-.25-.04-.44-.13-.56-.26-.13-.13-.19-.3-.19-.51 0-.27.1-.48.31-.64.2-.16.48-.24.83-.24.21 0 .42.04.63.11.21.07.4.17.56.3l-.32.45c-.15-.12-.31-.21-.45-.26-.15-.06-.3-.08-.46-.08-.16 0-.29.03-.38.09-.1.06-.14.14-.14.24 0 .09.03.16.09.21.06.05.17.09.32.11l.54.09c.29.05.5.14.65.27.15.13.22.32.22.54 0 .28-.11.5-.33.67-.22.17-.52.25-.89.25-.23 0-.46-.04-.68-.13-.23-.11-.43-.23-.61-.39zM13.66 35.88H13l-.68-3.05h.65l.41 2.07.6-2.07h.59l.59 2.06.41-2.06h.63l-.68 3.05h-.66l-.61-2.13z" />
        <g stroke="#A19A98" stroke-linecap="round" stroke-linejoin="round">
          <path d="M28.81 14.53v-3.56M48.63 34.35h3.55M28.81 54.18v3.55M8.98 34.35H5.43" />
          <path d="M42.82 20.34l2.52-2.52M42.82 48.37l2.52 2.51M14.79 48.37l-2.52 2.51M14.79 20.34l-2.52-2.52" />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    animated: { type: Boolean, default: false },
  },
}
</script>

<style>
.spinner {
  transform-origin: 50% 50%;
  transform-box: fill-box;
}
.spinner-frame {
  animation: spinner-frame 4s ease-in-out infinite;
}
.spinner-pointer {
  animation: spinner-pointer 4s ease-in-out infinite;
}
@keyframes spinner-frame {
  50% {
    transform: rotate(45deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes spinner-pointer {
  33% {
    transform: rotate(125deg);
  }
  66% {
    transform: rotate(-55deg);
  }
}
</style>
